import * as Address from '@/services/rest-api/lib/delivery/address'
import * as Vendor from '@/services/rest-api/lib/vendor/vendor'
import * as BoxType from '@/services/rest-api/lib/delivery/box-type'
import VendorStatus from '../../components/VendorStatus.vue'
import ReadOnly from '../../components/ReadOnly'
import { GET_CITIES, GET_PROVINCES } from '@/services/api/master/address'
import * as VehicleAvaibility from '@/services/rest-api/lib/fleet-task-instant/nearest-vehicle'
import * as DriverAvaibility from '@/services/rest-api/lib/fleet-task-instant/driver'
import * as Samator from '@/services/rest-api/lib/fleet-task/samator'
import { GET_USER_GROUP } from '@/services/api/setting/user/userGroup'
import * as ProductCategory from '@/services/rest-api/lib/product/product-category'
import * as Contract from '@/services/rest-api/lib/delivery/contract'
import * as Vehicle from '@/services/rest-api/lib/fleet-task/vehicle'
import i18n from '@/i18n'

import { formatNumber } from '@/helpers/format-number'
import { hasLineOrderFeatureAccess } from '@/helpers/tms-line-order'
import store from '@/state/store'
import { Helper } from '@/mixin/helper'

const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']
const hasAccessAll = store.getters['identity/hasAccessAll']
const hasTmsUserGroupAccess = hasAccessAll(['tms-user-group:read'])
const hasDriverCompatibility = hasAccessAll([
  'driver-compatibility:read',
  'driver-compatibility:update',
])

const hasSingleCategoryDeliveryAccess = hasAccessAll(['fleet-task-single-category-deliveries:read'])

let customFeature = {}
let selectedVehicleCategory
let selectedVehicleTypeId
let selectedVehicleId
let selectedDriverUserId
let selectedDriverUser2Id
let customerId
let customerContractType

export function setFleetTaskSelectedVehicleCategory(category) {
  if (category === undefined) {
    selectedVehicleCategory = undefined
    return
  }

  selectedVehicleCategory = category || null
}

function getSelectedVehicleCategory() {
  if (selectedVehicleCategory !== undefined) return selectedVehicleCategory
  return store.state.fleetTask.fleetTaskDetail?.custom_field?.vehicle_category_name || null
}

export function setFleetTaskSelectedVehicleTypeId(vehicleTypeId) {
  if (vehicleTypeId === undefined) {
    selectedVehicleTypeId = undefined
    return
  }

  selectedVehicleTypeId = vehicleTypeId || null
}

function getSelectedVehicleTypeId() {
  if (selectedVehicleTypeId !== undefined) return selectedVehicleTypeId
  return store.state.fleetTask.fleetTaskDetail?.custom_field?.vehicle_type_id || null
}

export function setFleetTaskSelectedVehicleId(vehicleId) {
  if (vehicleId === undefined) {
    selectedVehicleId = undefined
    return
  }

  selectedVehicleId = vehicleId || null
}

function getSelectedVehicleId() {
  if (selectedVehicleId !== undefined) return selectedVehicleId
  return store.state.fleetTask.fleetTaskDetail?.vehicle?.id || null
}

export function setFleetTaskSelectedDriverUserId(driverUserId) {
  if (driverUserId === undefined) {
    selectedDriverUserId = undefined
    return
  }

  selectedDriverUserId = driverUserId || null
}

function getSelectedDriverUserId() {
  if (selectedDriverUserId !== undefined) return selectedDriverUserId
  return store.state.fleetTask.fleetTaskDetail?.driver_user?.id || null
}

export function setFleetTaskSelectedDriverUser2Id(driverUser2Id) {
  if (driverUser2Id === undefined) {
    selectedDriverUser2Id = undefined
    return
  }

  selectedDriverUser2Id = driverUser2Id || null
}

function getSelectedDriverUser2Id() {
  if (selectedDriverUser2Id !== undefined) return selectedDriverUser2Id
  return store.state.fleetTask.fleetTaskDetail?.driver_user_2?.id || null
}

export function setFleetTaskCustomerContractType(contractType) {
  if (contractType === undefined) {
    customerContractType = undefined
    return
  }

  customerContractType = contractType?.toUpperCase().replace(/\s+/g, '_') || null
}

function getCustomerId() {
  if (customerId !== undefined) return customerId
  return store.state.fleetTask.fleetTaskDetail?.customer?.id || null
}

function getCustomerContractType() {
  if (customerContractType !== undefined) return customerContractType
  const value = store.state.fleetTask.fleetTaskDetail?.custom_field?.contract_type || null
  const result = value?.toUpperCase().replace(/\s+/g, '_')
  return result
}

function hasBinNumberSamator() {
  const data = getFeatureFlagValue('customFeature.samator')
  return Array.isArray(data?.company_id) && data.company_id.includes(Helper.methods.getCompanyId())
}

function hasFeatureFleetTaskContractMGM() {
  const data = getFeatureFlagValue('customFeature.mgm')
  customFeature.mgm = data
  return (
    Array.isArray(data?.company_id) &&
    data.company_id.includes(Helper.methods.getCompanyId()) &&
    data?.features?.fleet_task_contract
  )
}

let boxTypesByProductCategory = []
let boxTypesByProductCategorySourceId = null

const t = (key, params) => i18n.t(key, params)

function getAvailabilityStatus(val) {
  if (!val) {
    return { text: t('fleetTaskInstant.option.available'), class: 'mc-status mc-status--green' }
  }

  return { text: t('fleetTaskInstant.option.onAssignment'), class: 'mc-status mc-status--yellow' }
}

function createAvailabilityFilterOptions(selectedValueGetter) {
  return {
    get default() {
      return !selectedValueGetter() ? true : null
    },
    get options() {
      return [
        {
          key: 'all',
          label: t('fleetTaskInstant.option.all'),
          value: null,
        },
        {
          key: 'available',
          label: t('fleetTaskInstant.option.available'),
          value: true,
        },
        {
          key: 'not_available',
          label: t('fleetTaskInstant.option.onAssignment'),
          value: false,
        },
      ]
    },
  }
}

function clearBoxTypesByProductCategory() {
  boxTypesByProductCategory = []
  boxTypesByProductCategorySourceId = null
}

function getCurrentFleetTaskProductCategoryId() {
  return store.state.fleetTask.fleetTaskDetail?.product_category?.id || null
}

function getBoxTypesByProductCategoryForCurrentFleetTask() {
  if (!hasSingleCategoryDeliveryAccess) return []

  const currentProductCategoryId = getCurrentFleetTaskProductCategoryId()
  if (!currentProductCategoryId) return []
  if (boxTypesByProductCategorySourceId !== currentProductCategoryId) return []

  return boxTypesByProductCategory
}

async function getBoxTypeNamesByProductCategory(productCategoryId) {
  try {
    if (!productCategoryId) {
      clearBoxTypesByProductCategory()
      return
    }

    const res = await ProductCategory.show(productCategoryId)

    boxTypesByProductCategory = res?.data?.box_types?.map((box) => box.name) || []
    boxTypesByProductCategorySourceId = productCategoryId
  } catch (error) {
    clearBoxTypesByProductCategory()
  }
}

async function fetchCities(opts) {
  const citiesResponse = await this.$apollo.query({
    query: GET_CITIES,
    fetchPolicy: 'no-cache',
    variables: {
      filter: {
        pagination: {
          page: 1,
          show: 999,
        },
      },
    },
  })

  const provincesResponse = await this.$apollo.query({
    query: GET_PROVINCES,
    fetchPolicy: 'no-cache',
    variables: {
      filter: {
        pagination: {
          page: 1,
          show: 999,
        },
      },
    },
  })

  const citiesData = citiesResponse.data.data.cities.data
  const provincesData = provincesResponse.data.data.provinces.data

  const searchTerm = opts?.search?.toLowerCase() || ''

  const filteredCitiesData = searchTerm
    ? citiesData.filter((item) => item.name.toLowerCase().includes(searchTerm))
    : citiesData

  const filteredProvincesData = searchTerm
    ? provincesData.filter((item) => item.name.toLowerCase().includes(searchTerm))
    : provincesData

  const result = [
    {
      group: t('global.object.province'),
      libs: filteredProvincesData,
    },
    {
      group: t('global.object.city'),
      libs: filteredCitiesData,
    },
  ]

  return {
    metadata: {
      total_count: 5,
      page: 1,
    },
    data: {
      paginated_result: result,
    },
  }
}

async function fetchVehicleAvaibility(opts) {
  const fleetTask = store.state.fleetTask.fleetTaskDetail
  const boxType = store.state.fleetTask.fleetTaskDetail?.box_type?.id || null
  const productCategoryId = fleetTask?.product_category?.id || null
  const customerId = getCustomerId()
  const customerContract = getCustomerContractType()

  let start_address = fleetTask.start_address.geolocation
  if (start_address) {
    opts = {
      ...opts,
      latitude: start_address.coordinate.latitude,
      longitude: start_address.coordinate.longitude,
    }
  }

  if (hasTmsUserGroupAccess && Helper.methods.isSuperUser() && fleetTask?.user_group?.id) {
    opts = {
      ...opts,
      user_group_id: fleetTask.user_group.id,
    }
  }

  if (hasDriverCompatibility) {
    const vehicleCategory = getSelectedVehicleCategory()
    const vehicleTypeId = getSelectedVehicleTypeId()

    opts = {
      ...opts,
      vehicle_category: vehicleCategory ?? undefined,
      vehicle_type_id: vehicleTypeId,
    }
  }

  if (boxType) {
    opts = {
      ...opts,
      box_type_id: boxType,
    }
  }

  if (productCategoryId && hasSingleCategoryDeliveryAccess) {
    await getBoxTypeNamesByProductCategory(productCategoryId)
    opts = {
      ...opts,
      product_category_id: productCategoryId,
    }
  }

  if (customerId && hasFeatureFleetTaskContractMGM()) {
    opts = {
      ...opts,
      customer_id: customerId,
    }
  }

  if (customerContract && hasFeatureFleetTaskContractMGM()) {
    opts = {
      ...opts,
      contract_type: customerContract,
    }
  }

  const response = await VehicleAvaibility.get(opts)
  return {
    metadata: {
      total_count: response?.data?.total_count,
      page: 1,
    },
    data: {
      paginated_result: response?.data?.result,
    },
    isPagination: false,
  }
}

async function fetchDriverAvailability(opts, driverType) {
  const fleetTask = store.state.fleetTask.fleetTaskDetail

  if (hasTmsUserGroupAccess && Helper.methods.isSuperUser() && fleetTask?.user_group?.id) {
    opts = {
      ...opts,
      user_group_id: fleetTask.user_group.id,
    }
  }

  if (hasDriverCompatibility) {
    const vehicleCategory = getSelectedVehicleCategory()

    opts = {
      ...opts,
      vehicle_category: vehicleCategory ?? undefined,
    }
  }

  return await DriverAvaibility.get(opts)
}

async function fetchBinNumber(opts) {
  const fleetTask = store.state.fleetTask.fleetTaskDetail
  const startAddressId = fleetTask?.start_address?.id || null

  if (startAddressId) {
    opts = {
      ...opts,
      address_ids: startAddressId,
    }
  }

  const response = await Samator.get(opts)
  return {
    metadata: {
      total_count: response?.metadata?.total_count || 0,
      page: response?.metadata?.page || 1,
    },
    data: {
      paginated_result: response?.data || [],
    },
  }
}

async function fetchFleetTaskType() {
  const result = [
    {
      id: 'Internal Isi',
      name: t('fleetTask.formFields.assignmentOptions.internalLoad'),
    },
    {
      id: 'Internal Kosong',
      name: t('fleetTask.formFields.assignmentOptions.internalEmpty'),
    },
    {
      id: 'External',
      name: t('fleetTask.formFields.assignmentOptions.external'),
    },
  ]

  return {
    metadata: {
      total_count: result.length,
      page: 1,
    },
    data: {
      paginated_result: result,
    },
  }
}

async function fetchContractType() {
  const customerId = getCustomerId()

  let customer_id = null

  if (customerId) {
    customer_id = customerId
  }

  const response = await Contract.getCustomerContractType({
    customer_id,
  })

  return {
    metadata: {
      total_count: response?.data?.length || 0,
      page: 1,
    },
    data: {
      paginated_result:
        response?.data?.map((item) => ({
          ...item,
          disabled: item.available === false,
        })) || [],
    },
  }
}

async function fetchFleetCategory(opts) {
  const customerId = getCustomerId()
  const customerContract = getCustomerContractType()

  const filters = []

  if (customerId) {
    filters.push(`customer_id eq '${customerId}'`)
  }

  if (customerContract) {
    filters.push(`contract_type eq '${customerContract}'`)
  }

  const response = await Vehicle.getVehicleCategory({
    ...opts,
    filters,
  })

  return response
}

async function fetchFleetType(opts) {
  const customerId = getCustomerId()
  const customerContract = getCustomerContractType()
  const category = getSelectedVehicleCategory()

  const filters = []

  if (customerId) {
    filters.push(`customer_id eq '${customerId}'`)
  }

  if (customerContract) {
    filters.push(`contract_type eq '${customerContract}'`)
  }

  if (category) {
    filters.push(`category eq '${category}'`)
  }

  const response = await Vehicle.getVehicleType({
    ...opts,
    filters,
  })

  return response
}

export const userGroupField = {
  name: 'user_group_id',
  label: '',
  type: 'value-help-v2',
  placeholder: `${t('global.form.select')} ${t('global.field.userGroup')}`,
  trackBy: 'id',
  displayedBy: 'name',
  isMandatory: true,
  alertText: t('fleetTask.formFields.userGroup.alertText'),
  description: t('fleetTask.formFields.userGroup.description'),
  listGetter: async function (opts) {
    let result = {}
    const filter = {
      pagination: {
        page: opts?.page,
        show: opts?.limit,
      },
      search: opts?.search,
    }

    const res = await this.$apollo.query({
      query: GET_USER_GROUP,
      fetchPolicy: 'no-cache',
      variables: {
        filter: {
          ...filter,
        },
      },
    })

    const ugroups = res.data.ugroups.ugroups

    result = {
      metadata: {
        total_count: ugroups.pagination.total,
        page: ugroups.pagination.page,
      },
      data: {
        paginated_result: ugroups.data,
      },
    }

    return result
  },
  tableFields: [
    {
      label: t('global.field.userGroup'),
      key: 'name',
      isSortable: false,
    },
    {
      label: t('global.field.vehicleGroup'),
      key: 'vgroups',
      isSortable: false,
      formatter: (value) => {
        return value?.length != null
          ? value.length === 0
            ? t('global.text.allVehicleGroup')
            : value.length
          : '-'
      },
    },
  ],
}

export const baseTemporaryFleetTaskDetailFields = [
  {
    type: 'date-picker',
    name: 'expected_departure_on',
    label: 'fleetTask.fields.departureTime',
    placeholder: 'fleetTask.formFields.placeholder.departureTime',
    datepickerType: 'datetime',
    format: 'DD MMM YYYY HH:mm',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    showSecond: false,
    confirm: true,
    confirmText: t('global.apply'),
  },
  {
    type: 'text',
    name: 'shipment_reference',
    label: 'global.field.shipmentReference',
    placeholder: 'global.field.shipmentReference',
    validation: 'max:255,length',
    validationBehavior: 'live',
    errorBehavior: 'live',
    disabled: false,
  },
  {
    type: 'value-help',
    name: 'start_address_id',
    label: 'fleetTask.sequence.startPoint',
    placeholder: 'fleetTask.placeholder.startingPoint',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: Address.get('is_garage eq true'),
    getInitialObject: (data) => data?.start_address,

    tableFields: [
      {
        label: t('fleetTask.fields.garage'),
        key: 'name',
        isSortable: true,
        isRedirectable: true,
      },
      {
        label: t('global.field.address'),
        key: 'full_name',
        isSortable: true,
      },
    ],
  },
  {
    type: 'value-help',
    name: 'end_address_id',
    label: 'fleetTask.sequence.endPoint',
    placeholder: 'fleetTask.formFields.placeholder.endPoint',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: Address.get('is_garage eq true'),
    getInitialObject: (data) => data?.end_address,

    tableFields: [
      {
        label: t('fleetTask.fields.garage'),
        key: 'name',
        isSortable: true,
        isRedirectable: true,
      },
      {
        label: t('global.field.address'),
        key: 'full_name',
        isSortable: true,
      },
    ],
  },
  {
    type: 'select-resourceful',
    name: 'fleet_task_type',
    label: 'fleetTask.formFields.assignmentType',
    placeholder: 'fleetTask.formFields.placeholder.assignmentType',
    trackBy: 'id',
    displayedBy: 'name',
    type: 'select-resourceful',
    optionsGetter: fetchFleetTaskType,
    getInitialObject: (obj) => obj?.fleet_task_type,
    optionLabelFn: ({ item }) => item.name,
    isShow: hasFeatureFleetTaskContractMGM(),
  },
  {
    type: 'select-resourceful',
    name: 'contract_type',
    label: 'fleetTask.formFields.contractType',
    placeholder: 'fleetTask.formFields.placeholder.contractType',
    trackBy: 'id',
    displayedBy: 'name',
    type: 'select-resourceful',
    useInitialFallback: true,
    optionsGetter: fetchContractType,
    getInitialObject: (obj) => obj?.contract_type,
    optionLabelFn: ({ item }) => item.name,
    isShow: hasFeatureFleetTaskContractMGM(),
  },
  {
    type: 'select-resourceful',
    name: 'vehicle_category_name',
    label: 'global.field.vehicleCategory',
    placeholder: 'fleetTask.formFields.placeholder.vehicleCategory',
    trackBy: 'category',
    displayedBy: 'category',
    type: 'select-resourceful',
    useInitialFallback: true,
    optionsGetter: fetchFleetCategory,
    getInitialObject: (obj) => obj?.vehicle_category_name,
    optionLabelFn: ({ item }) => item.category,
    isShow: hasFeatureFleetTaskContractMGM(),
  },
  {
    type: 'select-resourceful-v2',
    name: 'vehicle_type_id',
    label: 'fleetTask.fields.vehicleType',
    placeholder: 'fleetTask.formFields.placeholder.vehicleType',
    trackBy: 'id',
    displayedBy: 'type',
    useInitialFallback: true,
    optionsGetter: fetchFleetType,
    getInitialObject: (obj) => obj?.vehicle_type_id,
    optionLabelFn: ({ item }) => `${item.manufacturer} - ${item.model} - ${item.type}`,
    selectedLabel: 'type',
    isShow: hasFeatureFleetTaskContractMGM(),
  },
  {
    type: 'value-help-v2',
    name: 'vehicle_id',
    label: 'global.field.licensePlate',
    placeholder: 'fleetTask.placeholder.licensePlate',
    trackBy: 'id',
    displayedBy: 'license_plate',
    subKey: 'hull_no',
    verticalAlign: 'middle',
    listGetter: fetchVehicleAvaibility,
    getInitialObject: (data) => data?.vehicle,
    get fullObject() {
      return store.state.fleetTask.fleetTaskDetail?.vehicle || null
    },
    tableFields: [
      {
        key: 'license_plate',
        label: t('global.field.licensePlate'),
        isSlot: true,
        slotComponent: 'DynamicCell',
        subKey: 'hull_no',
      },
      {
        key: 'vehicle_type.category',
        label: t('global.field.vehicleCategory'),
        isShow: hasDriverCompatibility,
      },
      {
        key: 'vehicle_type.type',
        label: t('fleetTask.fields.vehicleType'),
      },
      {
        key: 'box_type.name',
        label: t('fleetTask.fields.boxType'),
      },
      {
        key: 'fleet_task.id',
        label: t('fleetTask.fields.status'),
        help: true,
        tooltip: t('fleetTask.formFields.tooltip.vehicleStatus'),
        isStatus: true,
        formatter: (val) => getAvailabilityStatus(val),
      },
      {
        key: 'distance',
        label: t('global.field.distance'),
        help: true,
        tooltip: t('fleetTask.formFields.tooltip.distanceFromStart'),
        formatter: (distance) => {
          if (!distance) return '-'

          if (distance >= 1000) {
            return `${formatNumber(distance / 1000)} km`
          }
          return '< 1 km'
        },
        thStyle: 'min-width: 80px',
      },
      {
        key: 'fuel',
        label: t('global.field.fuel'),
        formatter: (fuel) => {
          if (!fuel) return '-'
        },
      },
      {
        key: 'driver.name',
        label: t('global.field.driver'),
      },
      {
        key: 'fleet_task.estimated_arrival_on',
        label: t('global.field.estimatedCompletion'),
        type: 'datetime',
      },
      {
        key: 'fleet_task',
        label: t('global.field.fleetTaskNumber'),
        type: 'redirectable',
        redirectTo: {
          FLEET_TASK: 'Fleet Task Detail',
          FLEET_TASK_INSTANT: 'Fleet Task Instant Detail',
        },
        redirectId: 'id',
        redirectLabel: 'number',
        formatter: (item) => {
          if (!item) {
            return ''
          }

          if (hasTmsUserGroupAccess && !Helper.methods.isSuperUser()) {
            const currentUserGroupId = store.state.fleetTask.fleetTaskDetail?.user_group?.id

            if (
              (item.user_group?.id &&
                currentUserGroupId &&
                item.user_group.id !== currentUserGroupId) ||
              item.user_group === null
            ) {
              return '-'
            }
          }

          return item
        },
        isClickable: (item) => {
          if (hasTmsUserGroupAccess && !Helper.methods.isSuperUser()) {
            const currentUserGroupId = store.state.fleetTask.fleetTaskDetail?.user_group?.id

            return (
              item?.user_group !== null &&
              item?.user_group?.id &&
              currentUserGroupId &&
              item.user_group.id === currentUserGroupId
            )
          }

          return item !== null
        },
      },
    ],
    filterOptions: createAvailabilityFilterOptions(getSelectedVehicleId),
    displayFilterOnly: {
      get isShow() {
        return getBoxTypesByProductCategoryForCurrentFleetTask().length > 0
      },
      name: t('fleetTask.fields.boxType'),
      key: 'box_type',
      get value() {
        return getBoxTypesByProductCategoryForCurrentFleetTask()
      },
    },
    isShow: true,
  },
  {
    type: 'read-only',
    name: 'box_type',
    title: t('fleetTask.fields.boxType'),
    isShow: true,
  },
  {
    type: 'value-help-v2',
    name: 'driver_user_id',
    label: 'global.field.primaryDriver',
    placeholder: 'fleetTask.placeholder.primaryDriver',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: (opts) => fetchDriverAvailability(opts, 'main-driver'),
    getInitialObject: (data) => data?.driver_user,
    get fullObject() {
      return store.state.fleetTask.fleetTaskDetail?.driver_user || null
    },
    tableFields: [
      {
        key: 'name',
        label: t('global.field.driver'),
      },
      {
        key: 'fleet_task.id',
        label: t('fleetTask.fields.status'),
        help: true,
        tooltip: t('fleetTask.formFields.tooltip.driverStatus'),
        isStatus: true,
        formatter: (val) => getAvailabilityStatus(val),
      },
      {
        key: 'vehicle_categories',
        label: t('global.field.vehicleCategory'),
        formatter: (val) => val[0],
        isShow: hasDriverCompatibility,
      },
      {
        key: 'phone_no',
        label: t('global.field.phoneNumber'),
      },
      {
        key: 'fleet_task.estimated_arrival_on',
        label: t('global.field.estimatedCompletion'),
        type: 'datetime',
      },
      {
        key: 'fleet_task',
        label: t('global.field.fleetTaskNumber'),
        type: 'redirectable',
        redirectTo: {
          FLEET_TASK: 'Fleet Task Detail',
          FLEET_TASK_INSTANT: 'Fleet Task Instant Detail',
        },
        redirectId: 'id',
        redirectLabel: 'number',
        formatter: (item) => {
          if (!item) {
            return ''
          }

          if (hasTmsUserGroupAccess && !Helper.methods.isSuperUser()) {
            const currentUserGroupId = store.state.fleetTask.fleetTaskDetail?.user_group?.id

            if (
              (item.user_group?.id &&
                currentUserGroupId &&
                item.user_group.id !== currentUserGroupId) ||
              item.user_group === null
            ) {
              return '-'
            }
          }

          return item
        },
        isClickable: (item) => {
          if (hasTmsUserGroupAccess && !Helper.methods.isSuperUser()) {
            const currentUserGroupId = store.state.fleetTask.fleetTaskDetail?.user_group?.id

            return (
              item?.user_group !== null &&
              item?.user_group?.id &&
              currentUserGroupId &&
              item.user_group.id === currentUserGroupId
            )
          }

          return item !== null
        },
      },
    ],
    filterOptions: createAvailabilityFilterOptions(getSelectedDriverUserId),
    isShow: true,
  },
  {
    type: 'value-help-v2',
    name: 'driver_user_2_id',
    label: 'global.field.additionalDriver',
    placeholder: 'fleetTask.placeholder.additionalDriver',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: (opts) => fetchDriverAvailability(opts, 'additional-driver'),
    getInitialObject: (data) => data?.driver_user_2,
    get fullObject() {
      return store.state.fleetTask.fleetTaskDetail?.driver_user_2 || null
    },
    tableFields: [
      {
        key: 'name',
        label: t('global.field.driver'),
      },
      {
        key: 'fleet_task.id',
        label: t('fleetTask.fields.status'),
        help: true,
        tooltip: t('fleetTask.formFields.tooltip.driverStatus'),
        isStatus: true,
        formatter: (val) => getAvailabilityStatus(val),
      },
      {
        key: 'vehicle_categories',
        label: t('global.field.vehicleCategory'),
        formatter: (val) => val[0],
        isShow: hasDriverCompatibility,
      },
      {
        key: 'phone_no',
        label: t('global.field.phoneNumber'),
      },
      {
        key: 'fleet_task.estimated_arrival_on',
        label: t('global.field.estimatedCompletion'),
        type: 'datetime',
      },
      {
        key: 'fleet_task',
        label: t('global.field.fleetTaskNumber'),
        type: 'redirectable',
        redirectTo: {
          FLEET_TASK: 'Fleet Task Detail',
          FLEET_TASK_INSTANT: 'Fleet Task Instant Detail',
        },
        redirectId: 'id',
        redirectLabel: 'number',
        formatter: (item) => {
          if (!item) {
            return ''
          }

          if (hasTmsUserGroupAccess && !Helper.methods.isSuperUser()) {
            const currentUserGroupId = store.state.fleetTask.fleetTaskDetail?.user_group?.id

            if (
              (item.user_group?.id &&
                currentUserGroupId &&
                item.user_group.id !== currentUserGroupId) ||
              item.user_group === null
            ) {
              return '-'
            }
          }

          return item
        },
        isClickable: (item) => {
          if (hasTmsUserGroupAccess && !Helper.methods.isSuperUser()) {
            const currentUserGroupId = store.state.fleetTask.fleetTaskDetail?.user_group?.id

            return (
              item?.user_group !== null &&
              item?.user_group?.id &&
              currentUserGroupId &&
              item.user_group.id === currentUserGroupId
            )
          }

          return item !== null
        },
      },
    ],
    filterOptions: createAvailabilityFilterOptions(getSelectedDriverUser2Id),
    isShow: true,
  },
  {
    type: 'value-help-v2',
    name: 'bin_num',
    label: 'fleetTask.formFields.binName',
    placeholder: 'fleetTask.formFields.placeholder.binName',
    trackBy: 'bin_num',
    displayedBy: 'bin_num',
    listGetter: fetchBinNumber,
    getInitialObject: (data) => data?.custom_field?.bin_number,
    get fullObject() {
      return store.state.fleetTask.fleetTaskDetail?.custom_field?.bin_number || null
    },
    tableFields: [
      {
        key: 'bin_num',
        label: t('fleetTask.formFields.binName'),
      },
      {
        key: 'warehouse_sku',
        label: t('fleetTask.formFields.warehouseSku'),
        formatter: (value, key, item) => {
          const warehouseCode = item?.warehouse_code
          const partNum = item?.part_num
          if (warehouseCode && partNum) {
            return `${warehouseCode} - ${partNum}`
          }
          return warehouseCode || partNum || '-'
        },
      },
    ],
    isShow: hasBinNumberSamator(),
  },
  {
    type: 'text',
    name: 'trailer_id',
    label: 'global.field.trailer',
    placeholder: 'global.field.trailer',
    requiresLiquid: true,
    isShow: hasBinNumberSamator(),
  }
]

export const temporaryFleetTaskDetailFields = baseTemporaryFleetTaskDetailFields
  .filter((field) => (typeof field.isShow === 'function' ? field.isShow() : field.isShow !== false))
  .map((field) => {
    const filteredField = Object.create(Object.getPrototypeOf(field))
    const descriptors = Object.getOwnPropertyDescriptors(field)
    Object.defineProperties(filteredField, descriptors)

    if (field.tableFields && Array.isArray(field.tableFields)) {
      filteredField.tableFields = field.tableFields.filter(
        (childField) => childField.isShow !== false
      )
    }

    return filteredField
  })

export const baseDraftFleetTaskDetailFields = [
  {
    type: 'date-picker',
    name: 'expected_departure_on',
    label: 'fleetTask.fields.departureTime',
    placeholder: 'fleetTask.formFields.placeholder.departureTime',
    validation: 'required',
    datepickerType: 'datetime',
    format: 'DD MMM YYYY HH:mm',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    showSecond: false,
    confirm: true,
    confirmText: t('global.apply'),
  },
  {
    type: 'text',
    name: 'shipment_reference',
    label: 'global.field.shipmentReference',
    placeholder: 'global.field.shipmentReference',
    validation: 'max:255,length',
    validationBehavior: 'live',
    errorBehavior: 'live',
    disabled: hasBinNumberSamator(),
  },
  {
    type: 'value-help',
    name: 'start_address_id',
    label: 'fleetTask.sequence.startPoint',
    placeholder: 'fleetTask.placeholder.startingPoint',
    validation: 'required',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: Address.get('is_garage eq true'),
    getInitialObject: (data) => data?.start_address,

    tableFields: [
      {
        label: t('fleetTask.fields.garage'),
        key: 'name',
        isSortable: true,
        isRedirectable: true,
      },
      {
        label: t('global.field.address'),
        key: 'full_name',
        isSortable: true,
      },
    ],
  },
  {
    type: 'value-help',
    name: 'end_address_id',
    label: 'fleetTask.sequence.endPoint',
    placeholder: 'fleetTask.formFields.placeholder.endPoint',
    validation: 'required',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: Address.get('is_garage eq true'),
    getInitialObject: (data) => data?.end_address,

    tableFields: [
      {
        label: t('fleetTask.fields.garage'),
        key: 'name',
        isSortable: true,
        isRedirectable: true,
      },
      {
        label: t('global.field.address'),
        key: 'full_name',
        isSortable: true,
      },
    ],
  },

  {
    type: 'select-resourceful',
    name: 'fleet_task_type',
    label: 'fleetTask.formFields.assignmentType',
    placeholder: 'fleetTask.formFields.placeholder.assignmentType',
    trackBy: 'id',
    displayedBy: 'name',
    type: 'select-resourceful',
    optionsGetter: fetchFleetTaskType,
    getInitialObject: (obj) => obj?.fleet_task_type,
    optionLabelFn: ({ item }) => item.name,
    isShow: hasFeatureFleetTaskContractMGM(),
    validation: 'required',
  },
  {
    type: 'select-resourceful',
    name: 'contract_type',
    label: 'fleetTask.formFields.contractType',
    placeholder: 'fleetTask.formFields.placeholder.contractType',
    trackBy: 'id',
    displayedBy: 'name',
    type: 'select-resourceful',
    useInitialFallback: true,
    optionsGetter: fetchContractType,
    getInitialObject: (obj) => obj?.contract_type,
    optionLabelFn: ({ item }) => item.name,
    isShow: hasFeatureFleetTaskContractMGM(),
    validation: 'required',
  },
  {
    type: 'select-resourceful',
    name: 'vehicle_category_name',
    label: 'global.field.vehicleCategory',
    placeholder: 'fleetTask.formFields.placeholder.vehicleCategory',
    trackBy: 'category',
    displayedBy: 'category',
    type: 'select-resourceful',
    useInitialFallback: true,
    optionsGetter: fetchFleetCategory,
    getInitialObject: (obj) => obj?.vehicle_category_name,
    optionLabelFn: ({ item }) => item.category,
    isShow: hasFeatureFleetTaskContractMGM(),
    validation: 'required',
  },
  {
    type: 'select-resourceful-v2',
    name: 'vehicle_type_id',
    label: 'fleetTask.fields.vehicleType',
    placeholder: 'fleetTask.formFields.placeholder.vehicleType',
    trackBy: 'id',
    displayedBy: 'type',
    useInitialFallback: true,
    optionsGetter: fetchFleetType,
    getInitialObject: (obj) => obj?.vehicle_type_id,
    optionLabelFn: ({ item }) => `${item.manufacturer} - ${item.model} - ${item.type}`,
    selectedLabel: 'type',
    isShow: hasFeatureFleetTaskContractMGM(),
    validation: 'required',
  },
  {
    type: 'value-help-v2',
    name: 'vehicle_id',
    label: 'global.field.licensePlate',
    placeholder: 'fleetTask.placeholder.licensePlate',
    trackBy: 'id',
    displayedBy: 'license_plate',
    subKey: 'hull_no',
    validation: 'required',
    get isMandatory() {
      const fleetTask = store.state.fleetTask.fleetTaskDetail
      return fleetTask?.status?.name === 'Dijadwalkan'
    },
    listGetter: fetchVehicleAvaibility,
    getInitialObject: (data) => data?.vehicle,
    get fullObject() {
      return store.state.fleetTask.fleetTaskDetail?.vehicle || null
    },
    tableFields: [
      {
        key: 'license_plate',
        label: t('global.field.licensePlate'),
        isSlot: true,
        slotComponent: 'DynamicCell',
        subKey: 'hull_no',
      },
      {
        key: 'vehicle_type.category',
        label: t('global.field.vehicleCategory'),
        isShow: hasDriverCompatibility,
      },
      {
        key: 'vehicle_type.type',
        label: t('fleetTask.fields.vehicleType'),
      },
      {
        key: 'box_type.name',
        label: t('fleetTask.fields.boxType'),
      },
      {
        key: 'fleet_task.id',
        label: t('fleetTask.fields.status'),
        help: true,
        tooltip: t('fleetTask.formFields.tooltip.vehicleStatus'),
        isStatus: true,
        formatter: (val) => getAvailabilityStatus(val),
      },
      {
        key: 'distance',
        label: t('global.field.distance'),
        help: true,
        tooltip: t('fleetTask.formFields.tooltip.distanceFromStart'),
        formatter: (distance) => {
          if (!distance) return '-'

          if (distance >= 1000) {
            return `${formatNumber(distance / 1000)} km`
          }
          return '< 1 km'
        },
        thStyle: 'min-width: 80px',
      },
      {
        key: 'fuel',
        label: t('global.field.fuel'),
        formatter: (fuel) => {
          if (!fuel) return '-'
        },
      },
      {
        key: 'driver.name',
        label: t('global.field.driver'),
      },
      {
        key: 'fleet_task.estimated_arrival_on',
        label: t('global.field.estimatedCompletion'),
        type: 'datetime',
      },
      {
        key: 'fleet_task',
        label: t('global.field.fleetTaskNumber'),
        type: 'redirectable',
        redirectTo: {
          FLEET_TASK: 'Fleet Task Detail',
          FLEET_TASK_INSTANT: 'Fleet Task Instant Detail',
        },
        redirectId: 'id',
        redirectLabel: 'number',
        formatter: (item) => {
          if (!item) {
            return ''
          }

          if (hasTmsUserGroupAccess && !Helper.methods.isSuperUser()) {
            const currentUserGroupId = store.state.fleetTask.fleetTaskDetail?.user_group?.id

            if (
              (item.user_group?.id &&
                currentUserGroupId &&
                item.user_group.id !== currentUserGroupId) ||
              item.user_group === null
            ) {
              return '-'
            }
          }

          return item
        },
        isClickable: (item) => {
          if (hasTmsUserGroupAccess && !Helper.methods.isSuperUser()) {
            const currentUserGroupId = store.state.fleetTask.fleetTaskDetail?.user_group?.id

            return (
              item?.user_group !== null &&
              item?.user_group?.id &&
              currentUserGroupId &&
              item.user_group.id === currentUserGroupId
            )
          }

          return item !== null
        },
      },
    ],
    filterOptions: createAvailabilityFilterOptions(getSelectedVehicleId),
    displayFilterOnly: {
      get isShow() {
        return getBoxTypesByProductCategoryForCurrentFleetTask().length > 0
      },
      name: t('fleetTask.fields.boxType'),
      key: 'box_type',
      get value() {
        return getBoxTypesByProductCategoryForCurrentFleetTask()
      },
    },
    isShow: true,
  },
  {
    type: 'read-only',
    name: 'box_type',
    title: t('fleetTask.fields.boxType'),
    isShow: true,
  },
  {
    type: 'value-help-v2',
    name: 'driver_user_id',
    label: 'global.field.primaryDriver',
    placeholder: 'fleetTask.placeholder.primaryDriver',
    trackBy: 'id',
    displayedBy: 'name',
    validation: 'required',
    get isMandatory() {
      const fleetTask = store.state.fleetTask.fleetTaskDetail
      return fleetTask?.status?.name === 'Dijadwalkan'
    },
    listGetter: (opts) => fetchDriverAvailability(opts, 'main-driver'),
    getInitialObject: (data) => data?.driver_user,
    get fullObject() {
      return store.state.fleetTask.fleetTaskDetail?.driver_user || null
    },
    tableFields: [
      {
        key: 'name',
        label: t('global.field.driver'),
      },
      {
        key: 'fleet_task.id',
        label: t('fleetTask.fields.status'),
        help: true,
        tooltip: t('fleetTask.formFields.tooltip.driverStatus'),
        isStatus: true,
        formatter: (val) => getAvailabilityStatus(val),
      },
      {
        key: 'vehicle_categories',
        label: t('global.field.vehicleCategory'),
        formatter: (val) => val[0],
        isShow: hasDriverCompatibility,
      },
      {
        key: 'phone_no',
        label: t('global.field.phoneNumber'),
      },
      {
        key: 'fleet_task.estimated_arrival_on',
        label: t('global.field.estimatedCompletion'),
        type: 'datetime',
      },
      {
        key: 'fleet_task',
        label: t('global.field.fleetTaskNumber'),
        type: 'redirectable',
        redirectTo: {
          FLEET_TASK: 'Fleet Task Detail',
          FLEET_TASK_INSTANT: 'Fleet Task Instant Detail',
        },
        redirectId: 'id',
        redirectLabel: 'number',
        formatter: (item) => {
          if (!item) {
            return ''
          }

          if (hasTmsUserGroupAccess && !Helper.methods.isSuperUser()) {
            const currentUserGroupId = store.state.fleetTask.fleetTaskDetail?.user_group?.id

            if (
              (item.user_group?.id &&
                currentUserGroupId &&
                item.user_group.id !== currentUserGroupId) ||
              item.user_group === null
            ) {
              return '-'
            }
          }

          return item
        },
        isClickable: (item) => {
          if (hasTmsUserGroupAccess && !Helper.methods.isSuperUser()) {
            const currentUserGroupId = store.state.fleetTask.fleetTaskDetail?.user_group?.id

            return (
              item?.user_group !== null &&
              item?.user_group?.id &&
              currentUserGroupId &&
              item.user_group.id === currentUserGroupId
            )
          }

          return item !== null
        },
      },
    ],
    filterOptions: createAvailabilityFilterOptions(getSelectedDriverUserId),
    isShow: true,
  },
  {
    type: 'value-help-v2',
    name: 'driver_user_2_id',
    label: 'global.field.additionalDriver',
    placeholder: 'fleetTask.placeholder.additionalDriver',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: (opts) => fetchDriverAvailability(opts, 'additional-driver'),
    getInitialObject: (data) => data?.driver_user_2,
    get fullObject() {
      return store.state.fleetTask.fleetTaskDetail?.driver_user_2 || null
    },
    tableFields: [
      {
        key: 'name',
        label: t('global.field.driver'),
      },
      {
        key: 'fleet_task.id',
        label: t('fleetTask.fields.status'),
        help: true,
        tooltip: t('fleetTask.formFields.tooltip.driverStatus'),
        isStatus: true,
        formatter: (val) => getAvailabilityStatus(val),
      },
      {
        key: 'vehicle_categories',
        label: t('global.field.vehicleCategory'),
        formatter: (val) => val[0],
        isShow: hasDriverCompatibility,
      },
      {
        key: 'phone_no',
        label: t('global.field.phoneNumber'),
      },
      {
        key: 'fleet_task.estimated_arrival_on',
        label: t('global.field.estimatedCompletion'),
        type: 'datetime',
      },
      {
        key: 'fleet_task',
        label: t('global.field.fleetTaskNumber'),
        type: 'redirectable',
        redirectTo: {
          FLEET_TASK: 'Fleet Task Detail',
          FLEET_TASK_INSTANT: 'Fleet Task Instant Detail',
        },
        redirectId: 'id',
        redirectLabel: 'number',
        formatter: (item) => {
          if (!item) {
            return ''
          }

          if (hasTmsUserGroupAccess && !Helper.methods.isSuperUser()) {
            const currentUserGroupId = store.state.fleetTask.fleetTaskDetail?.user_group?.id

            if (
              (item.user_group?.id &&
                currentUserGroupId &&
                item.user_group.id !== currentUserGroupId) ||
              item.user_group === null
            ) {
              return '-'
            }
          }

          return item
        },
        isClickable: (item) => {
          if (hasTmsUserGroupAccess && !Helper.methods.isSuperUser()) {
            const currentUserGroupId = store.state.fleetTask.fleetTaskDetail?.user_group?.id

            return (
              item?.user_group !== null &&
              item?.user_group?.id &&
              currentUserGroupId &&
              item.user_group.id === currentUserGroupId
            )
          }

          return item !== null
        },
      },
    ],
    filterOptions: createAvailabilityFilterOptions(getSelectedDriverUser2Id),
    isShow: true,
  },
  {
    type: 'value-help-v2',
    name: 'bin_num',
    label: 'fleetTask.formFields.binName',
    placeholder: 'fleetTask.formFields.placeholder.binName',
    trackBy: 'bin_num',
    displayedBy: 'bin_num',
    validation: 'required',
    get isMandatory() {
      const fleetTask = store.state.fleetTask.fleetTaskDetail
      return fleetTask?.status?.name === 'Dijadwalkan'
    },
    listGetter: fetchBinNumber,
    getInitialObject: (data) => data?.custom_field?.bin_number,
    get fullObject() {
      return store.state.fleetTask.fleetTaskDetail?.custom_field?.bin_number || null
    },
    tableFields: [
      {
        key: 'bin_num',
        label: t('fleetTask.formFields.binName'),
      },
      {
        key: 'warehouse_sku',
        label: t('fleetTask.formFields.warehouseSku'),
        formatter: (value, key, item) => {
          const warehouseCode = item?.warehouse_code
          const partNum = item?.part_num
          if (warehouseCode && partNum) {
            return `${warehouseCode} - ${partNum}`
          }
          return warehouseCode || partNum || '-'
        },
      },
    ],
    isShow: hasBinNumberSamator(),
  },
  {
    type: 'text',
    name: 'trailer_id',
    label: 'global.field.trailer',
    placeholder: 'global.field.trailer',
    requiresLiquid: true,
    isShow: hasBinNumberSamator(),
  }
]

export const draftFleetTaskDetailFields = baseDraftFleetTaskDetailFields
  .filter((field) => field.isShow !== false)
  .map((field) => {
    const filteredField = Object.create(Object.getPrototypeOf(field))
    const descriptors = Object.getOwnPropertyDescriptors(field)
    Object.defineProperties(filteredField, descriptors)

    if (field.tableFields && Array.isArray(field.tableFields)) {
      filteredField.tableFields = field.tableFields.filter(
        (childField) => childField.isShow !== false
      )
    }

    return filteredField
  })

export function fleetTaskListFields(vm) {
  return [
    {
      label: vm.$t('global.field.fleetTaskNumber'),
      key: 'number',
      isSortable: true,
      isRedirectable: true,
      hasOpenNewTab: true,
      isLocked: true,
      tdAttr: {
        style: 'left:49.5px;position:sticky;min-width:180px;max-width:180px;z-index:1;',
      },
      thAttr: {
        style: 'left:49.5px;position:sticky;min-width:180px;max-width:180px;z-index:1;',
      },
    },
    {
      label: vm.$t('global.field.shipmentReference'),
      key: 'shipment_reference',
      isSortable: true,
      isLocked: true,
      tdAttr: {
        style: `left:229.5px;position:sticky;min-width:180px;max-width:180px;z-index:1;`,
      },
      thAttr: {
        style: `left:229.5px;position:sticky;min-width:180px;max-width:180px;z-index:1;`,
      },
      columnTooltipLength: 20,
      columnHasTooltip: true,
    },
    {
      label: vm.$t('fleetTask.fields.status'),
      key: 'status.name',
      isSortable: true,
      isLocked: true,
      tdAttr: {
        style: `left:409.5px;position:sticky;z-index:1;`,
      },
      thAttr: {
        style: `left:409.5px;position:sticky;z-index:1;`,
      },
    },
    { label: vm.$t('global.field.departureTime'), key: 'expected_departure_on', isSortable: true },
    { label: vm.$t('global.field.startingPoint'), key: 'start_address.name', isSortable: true },
    { label: vm.$t('global.field.createdDate'), key: 'created_on', isSortable: true },
    {
      label: vm.$t('global.field.originAddress'),
      key: 'origin_addresses',
      isSortable: false,
    },
    {
      label: vm.$t('global.field.destinationAddress'),
      key: 'destination_addresses',
      isSortable: false,
    },
    {
      label: vm.$t('global.field.userGroup'),
      key: 'user_group.name',
      isSortable: false,
      isShow: hasTmsUserGroupAccess,
    },
    { label: vm.$t('global.field.licensePlate'), key: 'vehicle.license_plate', isSortable: true },
    {
      label: vm.$t('global.field.primaryDriver'),
      key: 'driver_user.name',
      isSortable: true,
    },
    {
      label: vm.$t('global.field.additionalDriver'),
      key: 'driver_user_2.name',
      isSortable: true,
      isShow: true,
    },
    {
      label: vm.$t('global.field.vendorName'),
      key: 'vendor.name',
      isSortable: true,
      scopes: ['vms:create', 'vms:read', 'vms:update', 'vms:delete'],
      isShow: true,
    },
    {
      label: vm.$t('global.field.tracking'),
      key: 'track_fo',
      isSortable: false,
      isLocked: true,
      tdAttr: {
        style: 'right:-30px;position:sticky;z-index:1;border-left:1px solid #e6e7ec',
      },
      thAttr: {
        style: 'right:-30px;position:sticky;z-index:1;border-left:1px solid #e6e7ec',
      },
    },
  ]
}

export const vendorFleetTaskDetailFields = [
  {
    type: 'vendor-value-help-v2',
    name: 'vendor_id',
    label: t('global.field.vendorName'),
    placeholder: `${t('global.form.select')} ${t('global.field.vendorName')}`,
    trackBy: 'id',
    validation: 'required',
    displayedBy: 'name',
    listGetter: Vendor.getContractRates,
    listGetterFilter: ['status.name eq ACTIVE', 'paired_company_id gt 0'],
    headerInfoComponent: ReadOnly,
    headerFilterComponent: [
      {
        name: 'box_type_name',
        type: 'select-resourceful-v2',
        trackBy: 'name',
        isGrouping: false,
        optionsGetter: BoxType.get,
        optionLabelFn: ({ item }) => item.name,
        placeholder: `${t('global.form.select')} ${t('fleetTask.fields.boxType')}`,
      },
      {
        name: 'origin_name',
        type: 'select-resourceful-v2',
        trackBy: 'name',
        isGrouping: true,
        optionsGetter: fetchCities,
        optionLabelFn: ({ item }) => item.name,
        placeholder: t('fleetTask.formFields.placeholder.origin'),
      },
      {
        name: 'destination_name',
        type: 'select-resourceful-v2',
        trackBy: 'name',
        isGrouping: true,
        optionsGetter: fetchCities,
        optionLabelFn: ({ item }) => item.name,
        placeholder: t('fleetTask.formFields.placeholder.destination'),
      },
    ],
    headerInfoProps: {
      items: [
        {
          key: 'origin',
          label: t('fleetTask.formFields.vendor.originCity'),
          bold: true,
          value: '',
        },
        {
          key: 'destination',
          label: t('fleetTask.formFields.vendor.destinationCity'),
          bold: true,
          value: '',
        },
        {
          key: 'total_weight',
          label: t('fleetTask.formFields.vendor.totalDoWeight'),
          bold: true,
          value: '',
        },
        {
          key: 'total_volume',
          label: t('fleetTask.formFields.vendor.totalDoVolume'),
          bold: true,
          value: '',
        },
      ],
    },
    tableFields: [
      {
        label: t('global.field.vendorName'),
        key: 'name',
        isSortable: false,
        isRedirectable: true,
        isEditable: true,
        validation: 'required',
        placeholder: `${t('global.form.enter')} ${t('global.field.vendorName')}`,
      },
      {
        label: t('fleetTask.formFields.vendor.connected'),
        key: 'status.name',
        name: 'status',
        isSlot: true,
        slotComponent: VendorStatus,
        thStyle: 'text-align:center;',
        tdAttr: {
          style: 'text-align:center;',
        },
      },
      {
        label: t('fleetTask.formFields.vendor.contractNumber'),
        key: 'contract_number',
      },
      {
        label: t('fleetTask.formFields.vendor.rate'),
        key: 'base_price',
        formatter: (value) => (value ? value.toLocaleString() : value),
      },
      {
        label: t('fleetTask.formFields.vendor.origin'),
        key: 'origin',
      },
      {
        label: t('fleetTask.formFields.vendor.destination'),
        key: 'destination',
      },
      {
        label: t('fleetTask.fields.boxType'),
        key: 'box_type',
      },
      {
        label: t('fleetTask.formFields.vendor.weightCapacity'),
        key: 'total_weight',
        formatter: (value) => (value ? value.toLocaleString() : value),
      },
      {
        label: t('fleetTask.formFields.vendor.volumeCapacity'),
        key: 'total_volume',
        formatter: (value) => (value ? value.toLocaleString() : value),
      },
    ],
  },
]
